import React, { useEffect, useRef } from "react";
import CalHeatmap from "cal-heatmap";
import Tooltip from "cal-heatmap/plugins/Tooltip";
import "cal-heatmap/cal-heatmap.css";

const MessageHeatmap = ({ frequencyData }) => {
  const containerRef = useRef(null);
  const calRef = useRef(null);

  useEffect(() => {
    // Ensure container exists and only run once
    if (!containerRef.current || calRef.current) return;
    if (!frequencyData || frequencyData.length === 0) return;

    const cal = new CalHeatmap();

    cal.paint({
      itemSelector: containerRef.current,
      date: { start: new Date(frequencyData[0].date), min: new Date(2015, 0) },
      range: 10,
      domain: { type: "year" },
      subDomain: { 
        type: "day", 
        width: 10, 
        height: 10,
        radius: 0
      },
      data: {
        source: frequencyData,
        x: 'date',
        y: 'value'
      },
      scale: {
        color: {
          type: "threshold",
          domain: [10, 20, 30],
          range: ['#441100', '#882200', '#bb3300', '#ff4400']
        }
      },
      theme: "dark"
    }, [[Tooltip, {
      text: (timestamp, value, dayjsDate) => `${dayjsDate.format('ddd MMM D, YYYY')}: ${value ? value : 'No'} Messages`
    }]]);

    calRef.current = cal;

    return () => {
      cal.destroy();
    };
  }, [frequencyData]);

  const handlePrevious = () => calRef.current?.previous();
  const handleNext = () => calRef.current?.next();

  return (
    <div className="container container-chart">
      <div ref={containerRef} style={{ overflowX: "auto", width: "100%" }} />
      <div style={{ marginTop: "10px" }}>
        <button className="button" onClick={handlePrevious}>Previous</button>
        <button className="button" onClick={handleNext}>Next</button>
      </div>
    </div>
  );
};

export default MessageHeatmap;
